import { setting } from "shared/types/Report";

/** Match the existing report editor defaults; teachers still choose word/sentence modes. */
export const defaultReportSetting: setting = {
    word: { focus: false, write: false, painting: false, word_repeat: 1, example_repeat: 1, word_write: 1, cutline: 3 },
    sentence: { cutline: 3, listening: false, order: false, sentence_repeat: 1, blank: 10, record: false, pass: 90 },
    video: { video: true, main_repeat: 1, video_repeat: 2 },
};
